import React from 'react';
import {Button} from 'react-bootstrap';
import SEO from './components/SEO/SEO';
import HeroSection from './components/HomePage/HeroSection';
import JourneySection from './components/HomePage/JourneySection';
import DoctorDogScenarioSection from './components/HomePage/DoctorDogScenarioSection';
import ProcessSection from './components/HomePage/ProcessSection';
import TestingSummarySection from './components/HomePage/TestingSummarySection';
import UseCasesPreview from './components/HomePage/UseCasesPreview';
import FounderSection from './components/HomePage/FounderSection';
import CTASection from './components/Common/CTASection';
import {useClarity} from './components/hooks/useClarity';
import HowItWorksSection from "./components/HomePage/HowItWorksSection";
import FinalStateSection from "./components/HomePage/FinalStateSection";

const DiscoveryCTA = ({location, label}) => {
    const {trackBookingClick} = useClarity();
    return (
        <div className="w-100 text-center my-4">
            <Button size="lg" variant="primary" className="cta-button"
                    href="https://cal.eu/jon-cooke/discovery-call"
                    onClick={() => trackBookingClick(location || 'homepage-inline')}>
                {label || 'Book a Discovery Call'}
            </Button>
        </div>
    );
};

function HomePage() {
    return (
        <>
            <SEO
                title="Nebulyx AI | Consistent AI for Regulated Industries"
                description="AI that reasons over your business. Cited, auditable, consistent. Same question, same answer, every time. Built for industries where trust isn't optional."
                canonicalUrl="https://nebulyx.ai/"
            />
            <div className="home-page">
                <HeroSection/>
                <JourneySection/>
                <HowItWorksSection/>
                <FinalStateSection/>
                <DoctorDogScenarioSection/>
                <DiscoveryCTA location="after-doctor-dog" label="See it work on your data →"/>
                <ProcessSection/>
                <TestingSummarySection/>
                <UseCasesPreview/>
                <FounderSection/>
                <CTASection/>
            </div>
        </>
    );
}

export default HomePage;